import * as React from 'react';

import classNames from 'classnames';

export class Loader extends React.Component<ILoaderAnimationProps, any> {
    constructor(props: ILoaderAnimationProps) {
        super(props);
    }

    render() {
        return (
            <div className="loader-backdrop">
                <LoaderAnimation />
            </div>
        );
    }
}

interface ILoaderAnimationProps {
    variant?: 'primary' | 'secondary';
    size?: 'xs' | 'sm' | 'lg';
}

export function LoaderAnimation(props: ILoaderAnimationProps) {
    const sizeClassName = props.size ? `loader-${props.size}` : '';
    const colorClassName = props.variant === 'secondary' ? 'loader-gray' : '';

    return (
        <div className={classNames('loader', sizeClassName, colorClassName)}>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    );
}
